/**
 * Capacitor build extras
 */
import { App } from '@capacitor/app'
import { PushNotifications } from '@capacitor/push-notifications'
import { FCM } from '@capacitor-community/fcm'

declare let window: any

App?.addListener('backButton', () => {
  const url = window.location.pathname
  const go = (url) => window.myNavigate && window.myNavigate(url)

  // If there is a modal open, close it.
  if (window.myModal && window.myModal.modal) {
    window.myModal.hide()
    return
  }
  console.log('*** BACK:', url)
  if (url === '/') {
    // App entry point, so the only "back" is exitting
    App.exitApp()
  } else if (url === '/soc') {
    go('/')
  } else if (url.match('/soc/change-installations/[0-9]+/(code|arm)')) {
    go('/soc/change-installations/' + url.split('/')[3])
  } else if (url.startsWith('/soc/change-installations/')) {
    go('/soc/installations')
  } else if (url === '/two-factor') {
    go('/soc/users/me')
  } else if (url === '/soc/users/me') {
    // Profile should go home, instead of to the user list (next branch)
    go('/soc')
  } else if (url.startsWith('/soc/users/')) {
    go('/soc/users')
  } else if (url.startsWith('/soc/')) {
    go('/soc')
  } else if (url.match('/manteinance/(corrective|preventive)/[0-9]+')) {
    go('/manteinance/' + url.split('/')[2])
  } else if (url.startsWith('/manteinance/')) {
    go('/manteinance')
  } else if (url.startsWith('/digital/')) {
    go('/digital')
  } else if (url === '/recover' || url === '/register') {
    // Not logged in routes, should go to login (at root)
    go('/')
  } else if (url === '/legal') {
    // Terms can only be accessed from register
    go('/register')
  } else if (url.startsWith('/change-pass/')) {
    // Recover email link should exit the app
    App.exitApp()
  } else {
    // Unknown route: Go back to the home
    go('/')
  }
})

App?.addListener('appUrlOpen', (data) => {
  const prefix = 'https://securityhub.securitas.es'
  const slug = data.url.substr(prefix.length)
  if (slug) {
    if (window.myNavigate) {
      window.myNavigate.push(slug)
    } else {
      window.myHistoryQueue = slug
    }
  }
})

const notificationInit = () => {
  PushNotifications.requestPermissions().then((result) => {
    if (result.receive === 'granted') {
      PushNotifications.register()
    } else {
      console.warn('Could not init notifications', result)
    }
  })

  PushNotifications.addListener('registration', (token) => {
    console.info('Notification init success; token:', token.value)
  })

  PushNotifications.addListener('registrationError', (error) => {
    console.warn('Could not init notifications:', error)
  })

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Notification:', notification)
  })

  PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification) => {
      console.log('Notification click:', notification)
    }
  )
}

window.fcmSubscribe = async () => {
  const state = window.store.getState()
  const id = state.user && state.user.user
  if (id) {
    const prevId = localStorage.getItem('_prevUser')
    if (prevId && prevId !== id) {
      try {
        await FCM.unsubscribeFrom({ topic: 'user-' + prevId })
      } catch (e) {
        console.warn("Couldn't unsubscribe from:", prevId, '/ Reason:', e)
      }
    }
    try {
      await FCM.subscribeTo({ topic: 'user-' + id })
      localStorage.setItem('_prevUser', id)
      console.log('Subscribed to topic:', id)
    } catch (e) {
      console.warn("Couldn't subscribe to:", id, '/ Reason:', e)
    }
  }
}

try {
  notificationInit()
} catch (e) {
  console.warn(e)
}
